var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
var usePagination = function (paginationProps) {
    var _a = paginationProps.current, defaultCurrent = _a === void 0 ? 1 : _a, _b = paginationProps.pageSize, defaultPageSize = _b === void 0 ? 10 : _b, onChanged = paginationProps.onChanged;
    var _c = useState({
        current: defaultCurrent,
        pageSize: defaultPageSize,
        changed: false,
    }), state = _c[0], setState = _c[1];
    var updatePagination = function (current, pageSize, changed) {
        if (changed === void 0) { changed = true; }
        setState(function (prevState) { return (__assign(__assign({}, prevState), { current: current, pageSize: pageSize, changed: changed })); });
    };
    useEffect(function () {
        if (state.changed) {
            setState(function (prevState) { return (__assign(__assign({}, prevState), { changed: false })); });
            onChanged && onChanged();
        }
    }, [state.changed]);
    return {
        state: state,
        updatePagination: updatePagination,
    };
};
export default usePagination;
//# sourceMappingURL=usePagination.js.map